import { HttpLink } from 'apollo-boost';
import Auth from '@aws-amplify/auth';
import { ApolloClient as Apollo } from 'apollo-boost'
//import { HttpLink } from 'apollo-boost'
import { InMemoryCache } from 'apollo-boost'
import { ApolloLink } from 'apollo-boost';
import { setContext } from 'apollo-link-context';
import { createUploadLink } from 'apollo-upload-client'

import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
// import { SchemaLink } from 'apollo-link-schema';



import { ApolloClient as ApolloClientInit} from 'architecture'

const introspectionQueryResultData = {
    __schema: {
      types: [{
        kind: 'UNION',
        name: 'InstanceType',
        possibleTypes: [{ name: 'TextInstance' }, { name: 'FileInstance' }]
      }]
  }
}

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

// const introspectionQueryResultData: {
//   __schema: {
//     types: [{
//       kind: 'UNION',
//       name: 'Item',
//       possibleTypes: [{ name: 'GreenItem' }, { name: 'RedItem }]
//     }]
//   }
// }};

const ApolloClient = ApolloClientInit(Auth, Apollo, HttpLink, InMemoryCache, ApolloLink, setContext, createUploadLink, fragmentMatcher)

export default ApolloClient 